/**
 * @example
 * getSetBitValue(0b00000001, 0b1) => 0b00000001; (no change)
 * getSetBitValue(0b00000010, 0b1) => 0b00000011; (changed)
 */
export const getSetBitValue = ( src: number, value: number ): number => src | value;
/**
 * @example
 * hasBitValue(0b00000001, 0b1) => true;
 * hasBitValue(0b00000010, 0b1) => false;
 */
export const hasBitValue = ( src: number, value: number ): boolean => ( src & value ) !== 0;
/**
 * @example
 * getDelBitValue(0b00000001, 0b1) => 0b00000000; (changed)
 * getDelBitValue(0b00000010, 0b1) => 0b00000010; (no change)
 */
export const getDelBitValue = ( src: number, value: number ): number => src & ~value;
